export default __webpack_public_path__ + "static/media/graciaslogotype.439b9890.svg";